import React, { useState, useEffect } from 'react';
import api from '../../../services/api';
import { Content, Main, SubContent } from '../../../components/Layout';
import { Row, Col } from 'react-bootstrap';
import Loading from '../../../components/Loading';
import { ModalConfirm, ModalUpload } from '../../../components/Modal';
import { toast } from 'react-toastify';
import useWrapper from '../../../hooks/useWrapper';
import { useOutletContext } from 'react-router-dom';
import FileDisplay from '../../../components/FileDisplay';
 
export default function Files() {
  const { commercial, reload, setreload } = useOutletContext();
  const { setbreadcrumb } = useWrapper();
  useEffect(() => {
    if (commercial?.institution?.name) {
      setbreadcrumb([
        { label: "Turmas", url: "/groups" },
        { label: commercial.institution.name }
      ])
    }
  }, [commercial]);

  return (
    <Main>
      {!!commercial ? (
        <Content noBG='true'>
          <Row>
              <Col>
                  <SubContent>
                    <div className="files">
                      <Row>
                        <Col>
                          <FileDisplay
                            files={commercial?.files || []}
                            commercial_id={commercial?.id}
                            reload={() => {
                              setreload(!reload);
                            }}
                            loading={!commercial}
                          />
                        </Col>
                      </Row>
                    </div>
                  </SubContent>
              </Col>
          </Row>
        </Content>
      ):(
        <Content>
          <Loading />
        </Content>
      )}
    </Main>
  );
}
